<button class="back-button" [routerLink]="['/medias']">
  <app-icon src="/assets/images/slide-right.svg"></app-icon>
  <span>Revenir à la plateforme</span>
</button>
<ng-content></ng-content>
